import {SecBEPermissionPartnerAppEnum} from '../shared/enums/sec-b-e-permission-partner-app-enum';

export class AppConstants {
    public static readonly WELCOME_MESSAGE = ' Herzlich Willkommen in <br>der Brother <br>Partner App';
    public static readonly APP_REQUIRED_PERMISSION_ARR = [SecBEPermissionPartnerAppEnum.PAU];  // permission required to access this app. Array is used to match other apps logic
    public static readonly LOGIN_URL: string = '/auth/login';
    public static readonly API_LOGIN_URL_NEW = '/v1/security/login';

    public static readonly LOCAL_STORAGE_PREFIX = 'dealerApp_';

    public static readonly EMAIL_PATTERN: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    public static readonly MIGRATED_USER_INFO_EMAIL = 'channel@brother.de';
}
